import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Axios from 'axios';
import { socketEmitEvent } from '../redux/actions';
import { LIST_STATE_DEVICES } from '../constants/service.types';
import { nextRequestId } from '../socket/query';

export const useGateways = (serials) => {
  const gatewayStates = useSelector((state) => state.gatewayStates);
  const namespace = useSelector((state) => state.namespace);

  const [ipAddress] = useState('0.0.0.0');
  const [requestId, setRequestId] = useState(nextRequestId());
  const [gateways, setGateways] = useState([]);
  const dispatch = useDispatch();

  const getDeviceStates = useCallback(
    (serialsString) => {
      let data = {
        namespace,
        serials: serialsString,
      };
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      let dataObj = {
        appServiceType: LIST_STATE_DEVICES,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  const stringifiedSerials = serials.join(';');

  useEffect(() => {
    stringifiedSerials.length && getDeviceStates(stringifiedSerials);
  }, [stringifiedSerials, getDeviceStates]);

  useEffect(() => {
    async function getInternalGateway(link, serial) {
      try {
        let result = await Axios.get(link);
        return result.status === 200 && result.data.serial === serial;
      } catch (error) {
        return false;
      }
    }
    if (gatewayStates && gatewayStates.requestId === requestId && ipAddress) {
      setGateways(
        gatewayStates.data.filter((gateway) => {
          if (
            ipAddress &&
            gateway.state === 1 &&
            gateway.ipAddress &&
            gateway.ipAddress === ipAddress &&
            gateway.localAddress &&
            gateway.localAddress.length > 0
          ) {
            return getInternalGateway(
              `http://${gateway.localAddress}:${gateway.portScan}/info`,
              gateway.serial
            );
          }
          return false;
        })
      );
    }
  }, [gatewayStates, ipAddress, requestId]);

  return {
    gateways,
  };
};
